"use client";

export { default } from "@/app/unlisted-shares/[...id]/product-error";
